import CenterContents from "../component/CenterContents"
import Accordion from "../component/Accordion" // or wherever your Accordion is
import InstructionComponent from "../component/instruction/InstructionComponent"
import SmallestHeadingComponent from "../component/SmallestHeadingComponent"

import AppDownloadInstructions from "../component/instruction/patient/AppDownloadInstructions"
import OuraSetupInstructions from "../component/instruction/patient/OuraSetupInstructions"
import AppLoginInstructions from "../component/instruction/patient/AppLoginInstructions"
import OuraConnectInstructions from "../component/instruction/patient/OuraConnectInstructions"

import CakeIcon from "../icon/CakeIcon"
import OuraSetupInstructionPart1 from "../component/instruction/patient/OuraSetupInstructionPart1"
import OuraSetupInstructionPart2 from "../component/instruction/patient/OuraSetupInstructionPart2"
import RegistrationStepOne from "../component/instruction/professional/RegistrationStepOne"
import RegistrationStepTwo from "../component/instruction/professional/RegistrationStepTwo"
import RegistrationStepThree from "../component/instruction/professional/RegistrationStepThree"

function ProfessionalHelpTutorialRegistrationView() {
  return (
    <CenterContents>
      <div className="w-full max-w-[1000px] m-5 flex flex-col space-y-8">

        {/* Accordion for the first two InstructionComponents */}
        <Accordion title="Registrierung Teil 1">
          <div className="flex flex-col space-y-8">
            <InstructionComponent {...RegistrationStepOne} />

          </div>
        </Accordion>
        
        {/* Accordion for the next two InstructionComponents */}
        <Accordion title="Registrierung Teil 2">
          <div className="flex flex-col space-y-8">
          <InstructionComponent {...RegistrationStepTwo} />
          </div>
        </Accordion>
        <Accordion title="Registrierung Teil 3">
          <div className="flex flex-col space-y-8">
          <InstructionComponent {...RegistrationStepThree} />
          </div>
        </Accordion>

        {/* Final Confirmation */}
        <div className="w-full flex flex-col space-y-2 py-10 items-center justify-center">
          <CakeIcon />
          <div>Sie haben die Registrierung erfolgreich abgeschlossen</div>
        </div>
      </div>
    </CenterContents>
  )
}

export default ProfessionalHelpTutorialRegistrationView
